"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class ExtendedTypesenseClient {
    constructor() {
        // core search function
        this.searchCollection = (options, collection) => __awaiter(this, void 0, void 0, function* () {
            try {
                const params = ExtendedTypesenseClient.getSearchParams(options);
                const res = yield moobiTypeSenseClient.collections(collection).documents().search(params);
                return res;
            }
            catch (error) {
                console.log(error);
                return null;
            }
        });
        // collection search function
        this.searchArticleColZH01 = (options) => __awaiter(this, void 0, void 0, function* () {
            const res = yield this.searchCollection(options, "shopify_articles_zh_01");
            return res;
        });
        this.searchProductsColZH01 = (options) => __awaiter(this, void 0, void 0, function* () {
            const res = yield this.searchCollection(options, "shopify_products_zh_01");
            return res;
        });
        this.client = new Typesense.SearchClient({
            nodes: [{
                    host: '2y9h70d3prw6uv8jp-1.a1.typesense.net',
                    port: '443',
                    protocol: 'https'
                }],
            apiKey: 'itq7jicFo1XypYg2paZKPQx0qxJFgbG6',
            connectionTimeoutSeconds: 2
        });
    }
    // create search params
    static getSearchParams(options) {
        const filterString = options.filterString ? `${options.filterBy}:${options.filterString}` : '';
        const params = {
            q: options.q,
            query_by: options.qby,
            sort_by: '_text_match:desc',
            facet_by: options.facetby || "",
            max_facet_values: 50,
            filter_by: filterString,
            per_page: options.perPage || 50,
            page: options.pageNo || 1
        };
        return params;
    }
}
const extendedTSClient = new ExtendedTypesenseClient();
const moobiTypeSenseClient = extendedTSClient.client;
